import {
  Datagrid,
  DateField,
  DeleteButton,
  EditButton,
  List,
  TextField,
  Create,
  SimpleForm,
  ReferenceInput,
  SelectInput,
  TextInput,
  NumberInput,
  AutocompleteInput,
  required,
  useNotify,
  useRedirect,
  SearchInput,
  DateInput,
  Filter,
  usePermissions,
  downloadCSV
} from 'react-admin';
import { unparse as convertToCSV } from 'papaparse';
import jsonExport from 'jsonexport/dist';
const ServiceFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <SelectInput
      source="service_type"
      label="Type"
      choices={[
        { id: "supply", name: "Supply" },
        { id: "demand", name: "Demand" },
      ]}
      allowEmpty
    />
    {/* <SelectInput
      source="status"
      label="Status"
      choices={[
        { id: "pending", name: "Pending" },
        { id: "approved", name: "Approved" },
        { id: "rejected", name: "Rejected" },
      ]}
      allowEmpty
    /> */}
    <ReferenceInput source="service_id" reference="servicetypes" label="Service" allowEmpty>
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
    <TextInput source="owner" label="Owner ID" />
    <DateInput source="created_at_gte" label="Created After" />
    <DateInput source="created_at_lte" label="Created Before" />
  </Filter>
);

const customExporter = (records) => {
  const csvData = records.map(record => ({
    Owner_Name: record.user?.name || "",
    Owner_PhoneNumber: record.user?.phonenumber ? `'${record.user.phonenumber}` : "",
    Location: record.user?._state?.name || "",
    ServiceName: record.service?.name || "",
    Description: record.description || "",
    PricePerDay: record.price_per_day || "",
    Type: record.service_type || "",
    Quantity: record.quantity || "",
    Payload: record.payload || "",
    Line: record.line || "",
    Temperature: record.temperature || "",
    Height: record.height || "",
    Space: record.space || "",
    NumberOfWorkers: record.number_of_workers || "",
    CreatedAt: record.created_at ? new Date(record.created_at).toLocaleDateString() : "",
    ServiceType: record.service_type || "",
    Status: record.status || "",
   
  }));

  jsonExport(csvData, { rowDelimiter: ',' }, (err, csv) => {
    if (err) {
      console.error(err);
      return;
    }
    // Add UTF-8 BOM to fix Arabic characters in Excel
    const bom = '\uFEFF';
    downloadCSV(bom + csv, 'services_export');
  });
};


const ServiceList = (props) => {
  return (
    <List {...props} filters={<ServiceFilter />} exporter={customExporter} >
      <Datagrid rowClick="edit">
        <TextField source="service.name" label="Service Name" />
        <TextField source="description" label="Description" />
        <TextField source="user.phonenumber" label="User Phone" />
        <TextField source="service_type" label="Type" />
        <TextField source="status" label="Status" />
        <DateField source="created_at" label="Date" />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};


export const ServiceCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { permissions } = usePermissions();
  const canEdit = permissions === "admin" || permissions === "operater";
  const transform = (data) => {
    console.log('Original form data:', data);

    const transformed = {
      owner: data.owner,
      service_id: Number(data.service_id),
      description: data.description,
      price_per_day: data.price_per_day || undefined,
      type: data.type || undefined,
      quantity: data.quantity || undefined,
      payload: data.payload || undefined,
      line: data.line || undefined,
      temperature: data.temperature || undefined,
      height: data.height || undefined,
      space: data.space || undefined,
      number_of_workers: data.number_of_workers || undefined,
      state: data.state ? Number(data.state) : undefined,
      city: data.city ? Number(data.city) : undefined,
      locality: data.locality ? Number(data.locality) : undefined,
      vehicle_type_id: data.vehicle_type_id ? Number(data.vehicle_type_id) : undefined,
      service_type: data.service_type || 'supply',
      status: data.status || 'active'
    };

    console.log('Transformed data:', transformed);
    return transformed;
  };

  const onSuccess = () => {
    notify('Service created successfully');
    redirect('list');
  };

  return (
    canEdit?  <Create {...props} transform={transform} mutationOptions={{ onSuccess }}>
      <SimpleForm className="max-w-6xl mx-auto">
        {/* Row 1: User and Service Type */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <ReferenceInput
            source="owner"
            reference="users"
            validate={[required()]}
          >
            <AutocompleteInput
              optionText="phonenumber"
              optionValue="id"
              label="User Phone"
              className="w-full"
            />
          </ReferenceInput>

          <ReferenceInput
            source="service_id"
            reference="servicetypes"
            validate={[required()]}
          >
            <SelectInput
              optionText="name"
              optionValue="id"
              label="Service Type"
              className="w-full"
            />
          </ReferenceInput>
        </div>

        {/* Row 2: Description */}
        <TextInput
          source="description"
          multiline
          validate={[required()]}
          label="Service Description"
          className="mb-6"
          fullWidth
        />

        {/* Row 3: Service Details */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          <SelectInput
            source="service_type"
            choices={[
              { id: 'supply', name: 'Supply' },
              { id: 'demand', name: 'Demand' },
            ]}
            defaultValue="supply"
            label="Service Type"
            className="w-full"
          />

          <TextInput
            source="price_per_day"
            label="Price Per Day (Optional)"
            className="w-full"
          />

          <ReferenceInput
            source="vehicle_type_id"
            reference="vehicle-types"
          >
            <SelectInput
              optionText="name"
              optionValue="id"
              label="Vehicle Type (Optional)"
              className="w-full"
            />
          </ReferenceInput>
        </div>

        {/* Row 4: Service Specifications */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          <TextInput
            source="type"
            label="Service Type (Optional)"
            className="w-full"
          />

          <TextInput
            source="quantity"
            label="Quantity (Optional)"
            className="w-full"
          />

          <TextInput
            source="payload"
            label="Payload Capacity (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 5: More Specifications */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          <TextInput
            source="line"
            label="Line/Route (Optional)"
            className="w-full"
          />

          <TextInput
            source="temperature"
            label="Temperature Control (Optional)"
            className="w-full"
          />

          <TextInput
            source="height"
            label="Height (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 6: Additional Details */}
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TextInput
            source="space"
            label="Storage Space (Optional)"
            className="w-full"
          />

          <TextInput
            source="number_of_workers"
            label="Number of Workers (Optional)"
            className="w-full"
          />
        </div>

        {/* Row 7: Location Information */}
        <div className="grid grid-cols-3 gap-6 mb-6">
          <ReferenceInput source="state" reference="state">
            <SelectInput
              optionText="name"
              optionValue="id"
              label="State (Optional)"
              className="w-full"
            />
          </ReferenceInput>

          <ReferenceInput source="city" reference="city">
            <SelectInput
              optionText="name"
              optionValue="id"
              label="City (Optional)"
              className="w-full"
            />
          </ReferenceInput>

          <ReferenceInput source="locality" reference="locality">
            <SelectInput
              optionText="name"
              optionValue="id"
              label="Locality (Optional)"
              className="w-full"
            />
          </ReferenceInput>
        </div>

        {/* Row 8: Status */}
        <SelectInput
          source="status"
          choices={[
            { id: 'active', name: 'Active' },
            { id: 'inactive', name: 'Inactive' },
            { id: 'pending', name: 'Pending' },
          ]}
          defaultValue="active"
          label="Status"
          className="w-full mb-6"
        />
      </SimpleForm>
    </Create>:undefined
  );
};


export default ServiceList;
